import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import ApiPath from "./ConstantApi";
import { RefundListResponse } from "../Helpers/Interfaces/RefundType";

export interface CreateCreditMemoRequest {
  orderItemId: string;
  orderNumber: string;
  // itemNumber: string;
  batch: string;
  metaId: string;
  customerId: string;
} 


export const RefundService = createApi({
  reducerPath: "Refunds",
  baseQuery: RtkBaseQueryWithReauth(process.env.REACT_APP_BASE_URL || "http://localhost:8000"),
  tagTypes: ["Refunds"],
  endpoints: (builder) => ({
    // Get all refunds list
    getRefundList: builder.mutation<RefundListResponse, any>({
      query: (reqBody) => ({
        url: "/getall/refunds",
        method: "POST",
        body: reqBody,
      }),
    }),
// Raising a refund from the admin side, for an item whose delivery failed.
    // Creates the request only; the money still moves through processRefund,
    // so approval, the service-fee decision and the invoice are unchanged.
    createAdminRefund: builder.mutation<any, {
      orderNumber: string;
      orderItemId: string;
      adminReason?: string;
    }>({
      query: (body) => ({
        url: "/adminrefunds/create",
        method: "POST",
        body,
      }),
    }),

processRefund: builder.mutation<any, {
  refundId: string,
  isAccepted: boolean,
  adminReason?: string,
  // Shown to the CUSTOMER on a declined refund. Deliberately not adminReason,
  // which is the internal record and reads like one.
  customerNote?: string,
  // The service fee is charged per order, so its treatment is decided once for
  // the order rather than per refunded item. Omitted when there is no fee to
  // decide, and ignored by the API if the order already has a decision.
  serviceFeeRefund?: { mode: "full" | "proportional" | "none", remarks?: string },
}>({
  query: ({ refundId, isAccepted, adminReason, customerNote, serviceFeeRefund }) => ({
    url: "/processRefund",
    method: "POST",
    body: {
      refundId,
      isAccepted,
      adminReason,
      customerNote,
      serviceFeeRefund,
    },
  }),
}),

    // Order, customer, fee and what each option would pay back. Costed by the
    // API so the figure shown is the figure refunded.
    getServiceFeeRefundPreview: builder.query<any, { orderNumber: string; orderItemId?: string }>({
      query: ({ orderNumber, orderItemId }) => ({
        // orderItemId so the item about to be approved counts towards the share,
        // alongside those already compensated on this order.
        url: `/refund/service-fee-preview/${orderNumber}${orderItemId ? `?orderItemId=${orderItemId}` : ""}`,
        method: "GET",
      }),
    }),

    processCreditMemo: builder.mutation<any, CreateCreditMemoRequest>({
      query: (body) => ({
        url: `/processcreditmemo`, // your endpoint
        method: "POST",
        body,
      }),
    }),



    
    
  }),
});

export const {
  useGetRefundListMutation,
  useCreateAdminRefundMutation,
useProcessRefundMutation,
useProcessCreditMemoMutation,
useLazyGetServiceFeeRefundPreviewQuery,
} = RefundService;
